export default __webpack_public_path__ + "static/media/IncUnselectedDataSortIcon.cb08896d.svg";